import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { InvoiceService } from '../../../providers/invoice.service';
import { UserService } from '../../../providers/user.service';
import { BaseComponent } from '../../shared/base/base.component';

@Component({
  selector: 'app-extra',
  templateUrl: './extra.component.html',
  styleUrls: ['./extra.component.scss']
})
export class ExtraComponent extends BaseComponent implements OnInit {
  extras: any = [];
  user: any;


  @Output() done: EventEmitter<object> = new EventEmitter<object>();


  constructor(public route: ActivatedRoute,
    public userService: UserService,
    public translator: TranslateService,
    public invoiceService: InvoiceService, private router: Router,
    public cookieService: CookieService,
    public titleService: Title,) {
    super(userService, translator, cookieService, titleService);
  }

  async ngOnInit() {
    this.extras = await this.userService.getExtras(this.user.username).toPromise();
  }

  addInvoice(extraPriceId) {

    this.invoiceService.addInvoice(this.selectedAccount, this.user.username, extraPriceId, 'extra').subscribe((result: any) => {
      this.done.emit();
      this.handleSuccess();
      // The API returns pg's flat rows now, so the row itself is result[0];
      // the old result[0][0] is undefined and reading .payable off it throws.
      if (result[0]?.payable) {
        this.router.navigate(['/sales/basket']);
      }
    }, error => {
      this.handleError(error);
    });
  }

}
